export enum AppendToBodyPositionTypeEnum {
    BOTTOM_LEFT = 'BottomLeft',
    TOP_RIGHT = 'TopRight',
    // Above the parent, aligned to its left edge: a menu that opens upward
    TOP_LEFT = 'TopLeft',
}
